<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [searchText]="searchText"
   [showCreate]="false"
   [hideHeader]="hideHeader"
   (create)="onCreate()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
>
   <ndt-register-create-options class="create-button">
      @if (canAddExtensions()) {
      <button
         type="button"
         mat-stroked-button
         color="primary"
         [matMenuTriggerFor]="createExtensionMenu"
         matTooltip="Create Extension"
         id="create-extension-button"
         >Add Extension
      </button>
      }
      <mat-menu #createExtensionMenu="matMenu">
         @for (createExtensionTypeOption of createExtensionTypeOptions; track createExtensionTypeOption) {
         <button mat-menu-item (click)="onCreateExtensionTypeSelected(createExtensionTypeOption)">
            {{ createExtensionTypeOption?.displayName }}
         </button>
         }
      </mat-menu>
   </ndt-register-create-options>
   <ndt-register-quick-filter>
      <mat-form-field>
         <mat-label>Filter by type</mat-label>
         <input
            [lcsSingleSelect]="extensionTypeSelect"
            ndtExtensionTypeSelect
            autocomplete="off"
            type="text"
            [ngModel]="selectedExtensionType"
            (ngModelChange)="onExtensionTypeSelected($event)"
            id="extension-type"
         />
         <ndt-extension-type-select #extensionTypeSelect isIncludeEmptyOption="true"></ndt-extension-type-select>
      </mat-form-field>
      <mat-slide-toggle
         class="quick-filter-checkbox"
         [ngModel]="showExtensionsWithIssues"
         (ngModelChange)="toggleShowExtensionsWithIssues($event)"
         id="filter-by-issues"
         color="primary"
      >
         <mat-label>Extensions with Issues </mat-label>
      </mat-slide-toggle>
   </ndt-register-quick-filter>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef="let extension"></tr>
         <ng-container lcsColumnDef="name" width="6">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="extensionName-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="name"
               >Name<mat-icon class="mat-icon-sort">{{ getSort('name') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let extension" class="phone-issues-chip-and-menu">
               <a [routerLink]="getRouterLink(extension.extensionId)">
                  {{ extension.name }}
               </a>
               @if ( isSystemUser && (extension.isHacked || extension.isFraud) && extension.type.displayName === 'Phone'
               ) {
               <phone-issues-chip-and-menu [extension]="extension"></phone-issues-chip-and-menu>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="number" width="3">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="extensionNumber-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="number"
               >Number<mat-icon class="mat-icon-sort">{{ getSort('number') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let extension">
               <a [routerLink]="getRouterLink(extension.extensionId)">
                  {{ extension.number }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="type" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="extensionType-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="extensionType.displayName"
               >Type<mat-icon class="mat-icon-sort">{{ getSort('extensionType.displayName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let extension">
               <a [routerLink]="getRouterLink(extension.extensionId)">
                  {{ extension.type.displayName }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="isConnected" width="3">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="extensionStatus-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="phoneRegistrationRank,number"
               >Status<mat-icon class="mat-icon-sort">{{ getSort('phoneRegistrationRank') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let extension">
               <a [routerLink]="getPhonesTabRouterLink(extension.extensionId)">
                  @if (extension.type.displayName === 'Phone') {
                  <phone-type-status-icons [statuses]="extension.phoneTypeStatuses"></phone-type-status-icons>
                  }
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="lastProvisionedDate" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="extensionType-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="phones.devices.lastProvisionedDate"
               >Last Provisioned Date<mat-icon class="mat-icon-sort">{{
                  getSort('phones.devices.lastProvisionedDate')
               }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let extension">
               <a [routerLink]="getRouterLink(extension.extensionId)">
                  {{
                     extension.type.displayName === 'Phone'
                        ? (extension.lastProvisionedDate | date : 'MM/dd/yyyy hh:mm aa')
                        : ''
                  }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="defaultPhoneNumber" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="defaultPhoneNumber-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="extensionPhone.defaultPhoneNumber.phoneNumber"
               >Default Phone Number<mat-icon class="mat-icon-sort">{{
                  getSort('extensionPhone.defaultPhoneNumber.phoneNumber')
               }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let extension">
               <a [routerLink]="getRouterLink(extension.extensionId)">
                  {{ extension.defaultPhoneNumber | formatPhoneNumbers }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="extensionsActionsMenu" width="3" class="extensions-menu">
            <th lcs-header-cell *lcsHeaderCellDef id="extension-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let extension" class="actions-menu-cell">
               <div class="extension-actions">
                  @if (extension.type.displayName === extensionTypes.Phone && showExtensionRegisterPopup != false) {
               <mat-icon
                  class="tooltip"
                  [appTooltip]="extension.extensionTooltip | extensionToolTipDisplay"
                  [useHtml]="true"
                  >information</mat-icon
               >
               }
               <button
                  type="button"
                  aria-label="Extension Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="extensionsMenu"
                  [matMenuTriggerData]="{ $implicit: promptItem, index: promptArrayIndex }"
                  [disabled]="disabled"
                  id="extension-register-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               </div>
               <mat-menu #extensionsMenu="matMenu">
                  <a mat-menu-item [routerLink]="getRouterLink(extension.extensionId)"> Details </a>
                  @if (isSystemUser && (extension.isHacked || extension.isFraud)) {
                  <button
                     mat-menu-item
                     type="button"
                     id="extensions-register-menu"
                     (click)="resetHackedAndFraudDevice(extension)"
                  >
                     Resolve issue
                  </button>
                  }
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
